let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d3O83")).then(() => parcelRequire('L9JRT'));